import apiFetch from '../apiFetch'

export default function (operationTypeId, token) {
  return apiFetch({ endPoint: `OperationType/${operationTypeId}/Recover`, method: 'PUT', body: null, token: token })
}
